<!--
 * @Author: 仙道
 * @Date: 2022-06-20 21:13:34
 * @LastEditTime: 2022-07-24 10:10:53
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/testGridLayout/index.vue
-->
<template>
  <grid-layout
    :auto-size="true"
    :breakpoints="{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }"
    :col-num="24"
    :is-draggable="draggable"
    :is-resizable="resizable"
    :layout.sync="_layout"
    :responsive="responsive"
    :row-height="100"
  >
    <!-- :cols="{ lg: 3, md: 2, sm: 2, xs: 1, xxs: 1 }" -->
    <grid-item
      :h="item.h"
      :i="item.i"
      :key="key"
      :minH="item.minH"
      :minW="item.minW"
      :w="item.w"
      :x="item.x"
      :y="item.y"
      @moved="movedEvent"
      @resized="movedEvent"
      v-for="(item,key) in _layout"
    >
      <slot :item="item" name="item"></slot>
    </grid-item>
  </grid-layout>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PageOne from '../components/PanelOne.vue'
  import PageTwo from '../components/PanelTwo.vue'

  import PageThree from '../components/PanelThree.vue'
  import PageFour from '../components/PanelFour.vue'
  import { GridLayout, GridItem } from "vue-grid-layout"
  import PendingOrder from '../components/pendingOrder.vue'
  import Calendar from '../components/calendar.vue'
  import quickMenu from '../components/quickMenu.vue'
  import DefRegister from '../components/defRegister.vue'
  import WaterRecord from '../components/WaterRecord.vue'
  import ViolationRecord from '../components/ViolationRecord.vue'
  import * as _ from 'lodash'

  export default {
    name: 'LayoutGrid',
    components: {
      quickMenu, PageOne, PageTwo, PageThree, PageFour, PendingOrder, Calendar, GridLayout, GridItem, WaterRecord, ViolationRecord
    },
    props: {
      layoutData: {
        type: Array,
        default: () => []
      },
      sortKey: {
        type: String,
        default: ''
      }
    },
    // 定义属性
    data () {
      return {
        responsive: true,
        resizable: true,
        draggable: true,
        testLayout1: [
          // 1. 自定义快捷入口菜单（可增删维护）；
          // 2. 待办工单；
          // 3. 未处理告警；
          // 4. 保养日历；
          // 5. 智能巡检：未复核的智能巡检记录表格；
          // 6. 备品备件（库存告警记录表格）、
          // 7. 设备切换提醒（这个功能还没有做）
          { x: 0, y: 0, w: 1, h: 1, i: "0", id: 0, title: '快捷菜单', component: "quickMenu" },//0列0行 宽为3块，高为5*rowHeight
          { x: 1, y: 0, w: 2, h: 1, i: "1", id: 1, title: '待办工单', component: "pendingOrder" },
          { x: 0, y: 1, w: 2, h: 3, i: "3", id: 2, minH: 3, minW: 2, title: '保养日历', component: "Calendar" },
          { x: 2, y: 1, w: 1, h: 1, i: "2", id: 3, title: '未处理告警', component: "PageThree" },

          { x: 2, y: 2, w: 1, h: 1, i: "4", id: 4, title: '备品备件', component: "PageOne" },
          { x: 0, y: 3, w: 2, h: 1, i: "5", id: 5, title: '智能巡检', component: "PageFour" },
          { x: 2, y: 3, w: 1, h: 1, i: "6", id: 6, title: '设备切换提醒', component: "PageTwo" },
          { x: 3, y: 0, w: 1, h: 1, i: "7", id: 7, title: '加水记录', component: "WaterRecord" },
          { x: 3, y: 0, w: 1, h: 1, i: "8", id: 8, title: '违规记录', component: "ViolationRecord" },
        ],
        _layout: []

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(),
    },
    // 监控data中的数据变化
    watch: {
      layoutData: {
        handler (arr) {

          this._layout = arr
          this.$forceUpdate() // 强制刷新
        },
        deep: true,
        immediate: true
      },

    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      createLayout (arr) {
        const col = this.colNum
        const res = arr.map((item, index) => {

          item.x = item.x
          item.y = item.y
          item.w = item.w
          item.h = item.h
          item.i = index
          item.a = '222'
          return item
        })
        return res



      },

      movedEvent (i) {

        // const arr = this.getMovedOrder().map((item) => {
        //   if (!this.sortKey) {
        //     return item
        //   } else {
        //     return item[this.sortKey]
        //   }
        // })
        // const moveItem = this._layout.find(item => item.i === i)
        // const componentItem = this.benchData
        this.$emit('moved', { i })
      },

      getMovedOrder () {
        const newLayout = [...this._layout]
        // 先按y(行)排，再按x(列)排序
        newLayout.sort((a, b) => {
          if (a.y !== b.y) {
            return a.y - b.y
          } else {
            return a.x - b.x
          }
        })
        return newLayout
      },
    }
  }
</script>

<style lang='less' scoped>
  .vue-grid-item {
    ::v-deep {
      .ant-card {
        height: 100%;
        border: 6px;
        box-shadow: 0 0 5px #cecece;
        transition-duration: 0.1s;
        display: flex;
        flex-direction: column;
        user-select: none;
        &-head {
          min-height: 30px;
          padding: 0 12px;
          border: none;
          font-size: 18px;
          font-weight: 700;
          &-wrapper {
            padding: 8px 0px;
          }
          &-title {
            padding: 0px;
          }
        }

        &-body {
          height: calc(100% - 49px);
          padding-top: 12px;
          margin-bottom: 5px;
          // overflow-y: scroll;
        }
      }
    }
  }
  .assistor {
    height: 60px;
    display: flex;
    // justify-content: end;
    flex-direction: row;
  }
</style>